/* eslint-disable react-hooks/exhaustive-deps */
import { Box, FormControl, InputLabel, MenuItem, Paper, Select, Typography, useTheme } from "@mui/material"
import { t } from "i18next";
import { useEffect, useState } from "react";
import { useFormikContext } from "formik";
import { useSelector } from "react-redux";
import { useLocation, useSearchParams } from "react-router-dom";
import PropTypes from "prop-types";



const CarStatus = ({ isClient }) => {
    const theme = useTheme();
    const formik = useFormikContext();
    const [searchParams] = useSearchParams();

    const formReducser = useSelector((state) => state.form);
    const vehicleId = searchParams.get(("vehicleId")) || null
    const location = useLocation();
    const inTransit = location.state?.inTransit;



    const [mainData, setMainData] = useState([])

    useEffect(() => {
        if (formReducser.loading === 'succeeded') {


            if (formReducser.data.statusList.length !== 0 && formik.values.status.id === undefined) {

                if (inTransit && inTransit === true) {
                    formik.setFieldValue('status', formReducser.data.statusList[0])
                } else {

                    formik.setFieldValue('status', formReducser.data.statusList[1])
                }
                //const filter = formReducser.data.statusList.filter(data => (data.id !== 2 && data.id !== 5 && data.id !== 7 && data.id !== 8));
                setMainData(formReducser.data.statusList)

            } else {
                let filter = formReducser.data.statusList;



                // if (formik?.values?.status?.id) {

                //     switch (formik?.values?.status?.id) {

                //         case 1:
                //             filter = formReducser.data.statusList.filter(data => (data.id !== 2 && data.id !== 5 && data.id !== 7 && data.id !== 8));

                //             break;

                //         case 6:
                //             filter = formReducser.data.statusList.filter(data => (data.id !== 1 && data.id !== 2 && data.id !== 7 && data.id !== 7));

                //             break;

                //         case 8:
                //             filter = formReducser.data.statusList.filter(data => (data.id !== 1 && data.id !== 2 && data.id !== 6));

                //             break;
                //         case 7:
                //             filter = formReducser.data.statusList.filter(data => (data.id !== 1 && data.id !== 6 && data.id !== 8));

                //             break;
                //         case 2:
                //             filter = formReducser.data.statusList.filter(data => (data.id !== 1 && data.id !== 6 && data.id !== 8 && data.id !== 7));

                //             break;

                //         default:
                //     }

                    

                // }







                setMainData(filter)

            }


        }

    }, [formReducser.loading])





    useEffect(() => {


        if (formik?.values?.status.id === 1) {




        }

    }, mainData)



    const noOfDays = () => {


        try {
            const date1 = new Date(formik?.values?.purchaseDate)
            const date2 = new Date(new Date().toISOString().substr(0, 10));
            const Difference_In_Time = date2.getTime() - date1.getTime();
            const Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
            return Difference_In_Days;
        } catch (error) {

        }
        return 0;
    }




    return (
        <Paper elevation={3} sx={{
                   borderRadius: 4,
                   boxShadow: '0 4px 24px 0 rgba(11, 60, 93, 0.10)',
                   bgcolor: theme.palette.background.paper,
                   p: { xs: 2, md: 4 },
                 
               
                   maxWidth: 1200,
                   mx: 'auto',
                 }}>
            <Box display='flex' flexDirection={{ xs: 'column', md: 'row' }} justifyContent='space-between' alignItems={{ xs: 'flex-start', md: 'center' }} gap={2}>
                <FormControl sx={{
                    width: { xs: '100%', md: '380px' },
                    height: '50px',
                    bgcolor: theme.palette.grey[100],
                    borderRadius: 2,
                    boxShadow: '0 1px 4px 0 rgba(11, 60, 93, 0.06)',
                }}>

                    <InputLabel sx={{ color: theme.palette.primary.main, fontWeight: 700 }}>{t("carStatus")}</InputLabel>

                    <Select
                        disabled={true}
                        value={formik.values.status?.id || ''}
                        onChange={(event) => {
                            const selectedValue = event.target.value;
                            const selectedOption = mainData.find((item) => item.id === selectedValue);
                            formik.setFieldValue('status', selectedOption || null);
                        }}
                        name='status'
                        sx={{
                            bgcolor: theme.palette.background.paper,
                            borderRadius: 2,
                            fontWeight: 700,
                            color: theme.palette.primary.main,
                            '& .MuiSelect-icon': { color: theme.palette.secondary.main },
                        }}
                    >
                        {mainData && mainData.map(item =>
                            <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                        )}
                    </Select>
                </FormControl>
                <Box sx={{
                    display: "flex",
                    alignItems: 'baseline',
                    bgcolor: theme.palette.grey[100],
                    borderRadius: 2,
                    px: 3,
                    py: 1,
                    boxShadow: '0 1px 4px 0 rgba(11, 60, 93, 0.06)',
                    minWidth: 120,
                    justifyContent: 'center',
                }}>
                    <Typography variant="h2" sx={{
                        fontWeight: 'bolder',
                        color: theme.palette.primary.main,
                        fontSize: { xs: 28, md: 36 },
                        mr: 1,
                    }} >
                        {noOfDays()}
                    </Typography>
                    <Typography variant="h6" sx={{
                        fontWeight: 'bolder',
                        color: theme.palette.secondary.main,
                        fontSize: { xs: 16, md: 20 },
                    }} >
                        Days
                    </Typography>
                </Box>
            </Box>
        </Paper >
    )
}

CarStatus.propTypes = {
    isClient: PropTypes.bool.isRequired,
};

export default CarStatus;
